<template>
  <div class="single-code-analysis-chart-container" :id="chartid"></div>
</template>

<script>
export default {
  name: 'TreemapChart',
  props: {
    chartid: String,
    charttitle: String,
    tooltip1: String,
    tooltip2: String,
    tooltip3: String,
    chartdata: {
      type: Array,
      default: () => []
    }
  },
  created() {
    this.$nextTick(() => {
      this.drawTreeMap(this.chartdata)
    });
  },
  computed: {
  },
  watch: {
    'chartdata'() {
      this.$nextTick(() => {
        this.drawTreeMap(this.chartdata)
      });
    },
  },
  mounted(){
    this.drawTreeMap(this.chartdata);
  },
  methods: {
    drawTreeMap: function(chartdata){
      let that = this
      let myBarChart = that.echarts.init(document.getElementById(that.chartid));
      myBarChart.clear()
      myBarChart.setOption({
        tooltip: {
          padding: 0,
          backgroundColor: 'rgba(50,50,50,0)',
          borderColor: 'rgba(50,50,50,0)',
          borderWidth: 0,
          formatter: function (obj) {
            return '<div style="padding:10px; min-width:200px; border-radius: 20px; background-color: rgba(50,50,50,0.8);">'
              + '<h2 style="font-size:16px; font-weight:normal; padding-bottom:10px; text-align: left;">' + obj.data.item + '</h2>'
              + '<h3 style="font-size:12px; font-weight:normal; border-top:1px solid #ddd; line-height:36px;">' + that.tooltip2 + '<span style="float:right;">'+ that.millonFormat(obj.data.value) + ' ' + obj.data.newunit + '</span></h3>'
              + '<h3 style="font-size:12px; font-weight:normal; border-top:1px solid #ddd; line-height:36px;">' + that.tooltip1 + '<span style="float:right;">'+ that.millonFormat(obj.data.proportion) +'%</span></h3>'
              + '<h3 style="font-size:12px; font-weight:normal; border-top:1px solid #ddd; line-height:36px;">' + that.tooltip3 + '<span style="float:right;">'+ that.millonFormat(obj.data.growth) + ' ' + obj.data.newunit + '</span></h3>'
              + '</div>'
              + '<div style="margin:auto; width: 0; height: 0; border-left: 20px solid transparent; border-right: 20px solid transparent; border-top: 20px solid rgba(50,50,50,0.8);"></div>'
          },
          position: function (point) {
            return [point[0] - 100, point[1] - 190]
          }
        },
        series: [{
          left: 10,
          right: 10,
          top: 30,
          bottom: 10,
          type: 'treemap',
          roam: false,
          nodeClick: false,
          breadcrumb: {
            show: false
          },
          label: {
            normal: {
              position: 'insideBottomLeft',
              formatter: function (params) {
                let arr = ['{name|' + params.data.item + '}', '{percent|' + params.data.proportion + '%}']
                return arr.join('\n')
              },
              rich: {
                name: {
                  fontSize: 14,
                  lineHeight: 20,
                  color: '#FFFFFF'
                },
                percent: {
                  fontSize: 12,
                  lineHeight: 18,
                  color: '#FFFFFF'
                },
              }
            }
          },
          //colorMappingBy: 'value',
          data: chartdata,
          itemStyle: {
            gapWidth: 1,
            borderColor: 'rgb(51,63,80)'
          }
        }],
        color: ['rgb(0,148,115)', 'rgb(51,102,153)', 'rgb(240,192,90)', 'rgb(190,69,116)', 'rgb(112,48,160)', 'rgb(150,79,76)']
      })

      $(window).resize(function () {
        myBarChart.resize();
      }) 
    },

  }
}
</script>